(() => {
  if (window.hfSyncPriceSortOptions) return;

  const isPriceSort = (value) => value === 'price-ascending' || value === 'price-descending';
  const hasStore = () => typeof window.hasPickingStore === 'function' && window.hasPickingStore();

  function sync() {
    const enabled = hasStore();
    document.querySelectorAll('[data-price-sort]').forEach((element) => {
      element.hidden = !enabled;
      if (element.matches('option, input')) element.disabled = !enabled;
      element.querySelectorAll('input').forEach((input) => { input.disabled = !enabled; });
    });

    document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      if (!enabled && isPriceSort(select.value)) {
        const fallback = Array.from(select.options).find((option) => !isPriceSort(option.value));
        if (fallback) select.value = fallback.value;
      }
      const dropdown = select.closest('sort-dropdown');
      if (!dropdown) return;
      dropdown.querySelectorAll('[role="option"]').forEach((option) => {
        const selected = option.dataset.value === select.value;
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-selected', String(selected));
      });
      const label = dropdown.querySelector('[data-sort-value]');
      const text = select.selectedOptions[0]?.textContent.trim();
      if (label && text && label.textContent !== text) label.textContent = text;
    });

    if (!enabled) {
      document.querySelectorAll('input[name="sort_by"]:checked').forEach((input) => {
        if (!isPriceSort(input.value)) return;
        input.checked = false;
        const fallback = Array.from(input.form?.querySelectorAll('input[name="sort_by"]') || [])
          .find((option) => !isPriceSort(option.value));
        if (fallback) fallback.checked = true;
      });
    }
  }

  function normalizeURL() {
    if (hasStore()) return;
    const url = new URL(window.location.href);
    if (!isPriceSort(url.searchParams.get('sort_by'))) return;
    url.searchParams.delete('sort_by');
    url.searchParams.delete('page');
    if (/^\/collections\//.test(url.pathname)) {
      window.location.replace(url.toString());
    } else {
      window.history.replaceState(window.history.state, '', url.toString());
    }
  }

  window.hfSyncPriceSortOptions = sync;
  function initialize() {
    sync();
    normalizeURL();
    new MutationObserver((records) => {
      if (records.some((record) => Array.from(record.addedNodes).some((node) =>
        node.nodeType === 1 && (node.matches('[data-price-sort], [name="sort_by"], sort-dropdown') ||
          node.querySelector('[data-price-sort], [name="sort_by"], sort-dropdown'))))) sync();
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('locationChanged', () => { sync(); normalizeURL(); });
  window.addEventListener('popstate', () => { sync(); normalizeURL(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
